module.exports = "https://cdn.realtymogul.com/static/media/img_returnsMRI.b2190344.png";